var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-top"},[_c('div',{staticClass:"tab-list"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,ref:"tabItem",refInFor:true,class:{on: _vm.active === item.id}},[_c('button',{on:{"click":function($event){return _vm.tabEvent(item.id)}}},[_c('span',{domProps:{"innerHTML":_vm._s(item.title)}})])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }